<template>
  <PortalPageShell
    :title="pageTitle"
    :subtitle="$t('portal.userManager')"
  >
    <div class="portal-form-card create-form">
      <div class="loader" v-if="loading"></div>
      <div class="form-group d-flex justify-content-start mt-4">
        <label for="name" class="align-self-center m-0">{{ $t("user.edituser.name") }}</label>
        <input type="text" class="form-control" id="name" aria-describedby="emailHelp" placeholder="Enter Name" v-model="user.name"/>
      </div>
      <div class="form-group d-flex justify-content-start">
        <label for="email" class="align-self-center m-0">{{ $t("user.edituser.email") }}</label>
        <input type="email" class="form-control" id="email" aria-describedby="emailHelp" placeholder="Enter Email" v-model="user.email"/>
      </div>
      <div class="form-group d-flex justify-content-start">
        <label for="exampleFormControlSelect1" class="align-self-center m-0">{{ $t("user.edituser.roles") }}</label>
        <select v-if="this.$router.currentRoute.name == 'new-user'" class="form-control" id="exampleFormControlSelect1" v-model="user.roles">
          <option v-for="(role, item) in getRoles" :value="role.id" :key="item">{{role.name}}</option>
        </select>
        <select v-if="this.$router.currentRoute.name == 'edit-user'" class="form-control" id="exampleFormControlSelect1" v-model="user.roles">
          <option v-for="(role, item) in getRoles" :value="role.name" :key="item">{{role.name}}</option>
        </select>
      </div>
      <div v-if="!airlineKey.includes('admin')">
        <div class="form-group d-flex justify-content-start" v-if="!(airlineKey.length>0)">
          <input type="checkbox" class="my-2 mx-2" v-model="checkbox" @click="check">
          <label class="align-self-center m-0">Limit access to below Airlines</label>
        </div>
      </div>
      <div v-else>
        <div class="form-group d-flex justify-content-start">
          <label for="air" class="align-self-center m-0">Limit access to below Airlines</label>
          <input type="checkbox" name="air" class="my-2 mx-2" v-model="checkbox" @click="check">
        </div>
      </div>
      <div class="form-group d-flex justify-content-start">
        <label for="exampleFormControlSelect2" class="align-self-center m-0">Airline:</label>
        <!-- <select class="form-control heightcheck" id="exampleFormControlSelect2" v-model="user.airline" :disabled="checkbox == false" multiple="multiple">
          <option v-for="(airline, item) in getAirline" :value="airline.name" :key="item">{{ formatName(airline.name) }}</option>
        </select> -->
        <div class="multi-select">
          <select2-multiple-control v-model="user.airline" :disabled="checkbox == false" :options="myOptions" />
        </div>
      </div>
      <!-- <h4>Value: {{ user.airline }}</h4> -->

      <div v-if="this.$router.currentRoute.name == 'new-user'">
        <div class="form-group d-flex justify-content-start">
          <label for="exampleInputPassword1" class="align-self-center m-0">{{ $t("createUser.password")}}:</label>
          <input type="password" class="form-control" placeholder="Password" id="exampleInputPassword1" v-model="user.password"/>
        </div>
      </div>

      <div v-if="this.$router.currentRoute.name == 'edit-user'">
        <div class="form-group d-flex justify-content-start">
          <div class="d-flex align-items-center">
            <input type="checkbox" name="pass" class="my-2 mx-2" v-model="pcheckbox" @click="pcheck">
            <label for="pass" class="align-self-center m-0" style="width : 200px;">Change Password</label>
          </div>
        </div>
        <div class="form-group d-flex justify-content-start">
          <div class="d-flex justify-content-between">
            <label for="exampleInputPassword1" class="align-self-center m-0">New Password</label>
          </div>
          <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" v-model="user.password" :disabled="pcheckbox == false" @keyup.enter="editUser" />
        </div>
      </div>
      
      <div class="errors mb-2">
        <p v-if="errors.length" style="color: red;">
          <ul >
            <li v-for="(error,idx) in this.errors" :key="idx">{{error}}</li>
          </ul>
        </p>
      </div>
      <div class="row d-flex justify-content-center">
        <button v-if="this.$router.currentRoute.name == 'edit-user'" type="submit" class="btn btn-primary submit" @click="editUser">Submit</button>
        <button v-if="this.$router.currentRoute.name == 'new-user'" type="submit" class="btn btn-primary submit" @click="createUser">{{ $t("createUser.btnSubmit")}}</button>
      </div>
    </div>
  </PortalPageShell>
</template>
<script>
import PortalPageShell from '../layout/PortalPageShell.vue';
import axios from 'axios';
import { routeNames } from '../../js/routeNames';
import { decryptData } from '../../js/utils/encrypt';
import Select2MultipleControl from 'v-select2-multiple-component';
export default {
  components: {
    PortalPageShell,
    Select2MultipleControl
  },
  data() {
    return {
      myOptions: [],
      loading: false,
      getRoles:'',
      getAirline: '',
      user: {
        name: '',
        email: '',
        roles: '',
        password: '',
        airline: []
      },
      errors:[],
      nameCheck: '',
      emailCheck: '',
      checkbox: false,
      airlineKey: [],
      pcheckbox: false,
    };
  },
  mounted() {
    this.loading = true;
    var airline = localStorage.getItem('Airline');
    if (!airline) {
      airline = 'null';
    }
    const secretPermissionKey = process.env.KEY || 'myscecretkey';
    var airlineData = decryptData(airline, secretPermissionKey);
    this.airlineKey = airlineData;
    if(airlineData.length == 0){
      this.airlineKey.push('admin');
    }
    if(!this.airlineKey.includes('admin')){
      for(let idx=0; idx<this.airlineKey.length ; idx++){
        this.user.airline.push(this.airlineKey[idx].name);
      }
      console.log('non admin airline', this.user.airline);
    }
    // console.log('airline key check', this.airlineKey);
    if(this.$router.currentRoute.name == 'edit-user'){
      this.user.name = this.$route.params.name;
      this.user.email = this.$route.params.email;
      this.user.roles = this.$route.params.role;
      this.nameCheck = this.$route.params.name;
      this.emailCheck = this.$route.params.email;

      let airlineArray = this.$route.params.airline;

      for(let i=0; i<airlineArray.length ; i++){
        this.user.airline[i] = airlineArray[i].name;
      }

      if(this.user.airline.length == 0){
        this.checkbox = false;
      }
      // else if (this.user.airline == this.airlineKey){
      //   this.checkbox = false;
      // }
      else{
        this.checkbox = true;
      }
    }

    

    if(this.$router.currentRoute.name != 'edit-user'){
      axios.get(this.$hostName + '/getAllRoles').then(response => {
        this.getRoles = response.data.roles;
        this.user.roles = this.getRoles[0].id;
      })
      .catch((error) => {
        console.log(error);
      });
    }
    else {
      axios.get(this.$hostName + '/getAllRoles').then(response => {
        this.getRoles = response.data.roles;
      })
      .catch((error) => {
        console.log(error);
      });
    }
    

    axios.get(this.$hostName + '/airlines/details')
    .then((response) => {
      this.getAirline = response.data;
      for(let i=0; i<this.getAirline.length;i++){
        this.myOptions.push(this.getAirline[i].name);
      }
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      this.loading = false;
    });
    
    
  },
  computed: {
    routeNames: () => { return routeNames; },
    pageTitle() {
      return this.$router.currentRoute.name === 'new-user'
        ? this.$t('createUser.title')
        : 'Edit User';
    },
  },
  methods: {
    formatName(name){
      if(name == null ){
        return name;
      }
      return name.split(/(?=[A-Z])/).join(' ');
    },
    check(){
      this.checkbox=!this.checkbox;
    },
    pcheck(){
      this.pcheckbox=!this.pcheckbox;
    },
    createUser(e) {
      console.log('check this', this.user.airline);
          this.errors = [];
          this.errorCheck(e);
          if(this.user.password==''){
            if(this.user.password==''){
              this.errors.push('Password required.');
            }
            if(this.user.password.length<6){
              this.errors.push('Minimum 6 characters required.');
            }
            if (!this.errors.length) {
              return true;
            }
              e.preventDefault();
             return;
          }

          this.loading = true;
            if(this.airlineKey.includes('admin')){
               axios.post(this.$hostName + '/account/create',{
                name: this.user.name,
                email: this.user.email,
                airline: this.user.airline,
                role: this.user.roles,
                password: this.user.password,
              }).then(response => {
                  if(response.status==202){
                    this.loading = false;
                    this.$alert('User already exists');
                  }
                  else if(response.status==203){
                    this.loading = false;
                    this.$alert('Email already exists');
                  }
                  else{
                    this.loading =  false;
                    this.$router.push({name: routeNames.manageUser});
                  }
              });
            }
            else{
              axios.post(this.$hostName + '/account/create',{
                name: this.user.name,
                email: this.user.email,
                airline: this.user.airline,
                role: this.user.roles,
                password: this.user.password,
              }).then(response => {
                  if(response.status==202){
                    this.loading = false;
                    this.$alert('User already exists');
                  }
                  else if(response.status==203){
                    this.loading = false;
                    this.$alert('Email already exists');
                  }
                  else{
                    this.loading =  false;
                    this.$router.push({name: routeNames.manageUser});
                  }
              });
            }
        },
    editUser(e){
      this.errorCheck(e);
      this.loading = true;
      if(this.airlineKey.includes('admin')){
        if(this.pcheckbox == true){
          axios.put(this.$hostName + '/account/update/'+ this.$route.params.userid,{
            name: this.user.name,
            email: this.user.email,
            roles: this.user.roles,
            airline: this.user.airline,
            password: this.user.password,
            nameCheck: this.nameCheck,
            emailCheck: this.emailCheck
          }).then(response =>{
            if(response.status==202){
              this.loading = false;
              this.$alert('User already exists');
            }
            else if(response.status==203){
              this.loading = false;
              this.$alert('Email already exists');
            }
            else{
              this.loading =  false;
            this.$router.push({name: routeNames.manageUser});
            }
          });
        }
        else{
          axios.put(this.$hostName + '/account/update/'+ this.$route.params.userid,{
            name: this.user.name,
            email: this.user.email,
            roles: this.user.roles,
            airline: this.user.airline,
            nameCheck: this.nameCheck,
            emailCheck: this.emailCheck
          }).then(response =>{
            if(response.status==202){
              this.loading = false;
              this.$alert('User already exists');
            }
            else if(response.status==203){
              this.loading = false;
              this.$alert('Email already exists');
            }
            else{
              this.loading =  false;
            this.$router.push({name: routeNames.manageUser});
            }
          });
        }
      }
      else {
        if(this.pcheckbox == true){
          axios.put(this.$hostName + '/account/update/'+ this.$route.params.userid,{
            name: this.user.name,
            email: this.user.email,
            roles: this.user.roles,
            airline: this.user.airline,
            password: this.user.password,
            nameCheck: this.nameCheck,
            emailCheck: this.emailCheck
          }).then(response =>{
            if(response.status==202){
              this.loading = false;
              this.$alert('User already exists');
            }
            else if(response.status==203){
              this.loading = false;
              this.$alert('Email already exists');
            }
            else{
              this.loading =  false;
            this.$router.push({name: routeNames.manageUser});
            }
          });
        }
        else{
          axios.put(this.$hostName + '/account/update/'+ this.$route.params.userid,{
            name: this.user.name,
            email: this.user.email,
            roles: this.user.roles,
            airline: this.user.airline,
            nameCheck: this.nameCheck,
            emailCheck: this.emailCheck
          }).then(response =>{
            if(response.status==202){
              this.loading = false;
              this.$alert('User already exists');
            }
            else if(response.status==203){
              this.loading = false;
              this.$alert('Email already exists');
            }
            else{
              this.loading =  false;
            this.$router.push({name: routeNames.manageUser});
            }
          });
        }
      }
    },
    errorCheck(e){
      this.errors = [];
      if(this.user.name=='' || this.user.email=='' || this.user.roles==''){
          if(this.user.name==''){
            this.errors.push('Name required.');
          }
          if(this.user.email==''){
            this.errors.push('Email required.');
          }
          if(this.user.roles==''){
            this.errors.push('Role required.');
          }
          if (!this.errors.length) {
            return true;
          }
          e.preventDefault();
          return;
      }
      if(this.user.name!='' || this.user.email!='' || this.user.password!=''){
        if(this.user.password.length<6 && this.pcheckbox == true){
          this.errors.push('Minimum 6 characters required.');
          return;
        }
        if(this.user.email!=''){
          if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email)){
            console.log('skip');
          }
          else{
            this.errors.push('Incorrect email format');
            return;
          }  
        }
      }
    },
    goToRoute(route) {
      if(this.navOpen) this.toggleNav();
      if(route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    }
  }
};
</script>

<style scoped>
.create-form {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5%;
}
.loader{  /* Loader Div Class */
    position: absolute;
    top:0px;
    right:0px;
    width:100%;
    height:100%;
    background-color:#eceaea;
    background-image: url('../../assets/loading.gif');
    background-size: 50px;
    background-repeat:no-repeat;
    background-position:center;
    z-index:10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
}
label{
  width: 120px;
}
.submit{
  font-size: 20px;
  font-weight: bold;
  width: 23%;
}
.heightcheck{
  height: 50px;
}
.multi-select{
  width: 100%;
  min-height: 40px;
  display: inline-block;
}
</style>